module.exports = __webpack_public_path__ + "static/media/hdijab.f7cb42c9.png";